import { api } from '@/lib/api';
import { useT } from '@/lib/i18n';
import { useTheme } from '@/lib/theme';
import { useSession } from '@/features/auth/store';
import { Icon } from './Icon';

export function ThemeSwitcher({ className = '' }: { className?: string }) {
  const t = useT();
  const { dark, toggle } = useTheme();
  const authenticated = useSession((state) => state.status === 'authenticated');

  function handleToggle() {
    const next = dark ? 'light' : 'dark';
    toggle();
    if (authenticated) {
      void api
        .patch('/account/profile', { settings: { theme: next } })
        .catch(() => undefined);
    }
  }

  return (
    <button
      type="button"
      onClick={handleToggle}
      title={dark ? t('Светлая тема') : t('Тёмная тема')}
      aria-label={dark ? t('Светлая тема') : t('Тёмная тема')}
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-heritage-200 bg-surface text-heritage-600 transition hover:bg-heritage-100 hover:text-heritage-800 ${className}`}
    >
      <Icon name={dark ? 'sun' : 'moon'} className="h-4 w-4" />
    </button>
  );
}
